export default "/images/vendor/quill/icons/align-left.svg?0f8ad7994ca19d6495042555af243eef";